/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ error: NonNullable<unknown> }} Knp_Manager_Permissions_Update_FailedInputs */

const en_knp_manager_permissions_update_failed = /** @type {(inputs: Knp_Manager_Permissions_Update_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Failed to update permissions: ${i?.error}`)
};

const fr_knp_manager_permissions_update_failed = /** @type {(inputs: Knp_Manager_Permissions_Update_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Échec de la mise à jour des autorisations : ${i?.error}`)
};

const de_knp_manager_permissions_update_failed = /** @type {(inputs: Knp_Manager_Permissions_Update_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Berechtigungen konnten nicht aktualisiert werden: ${i?.error}`)
};

const it_knp_manager_permissions_update_failed = /** @type {(inputs: Knp_Manager_Permissions_Update_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Impossibile aggiornare le autorizzazioni: ${i?.error}`)
};

const ru_knp_manager_permissions_update_failed = /** @type {(inputs: Knp_Manager_Permissions_Update_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Не удалось обновить права доступа: ${i?.error}`)
};

const es_knp_manager_permissions_update_failed = /** @type {(inputs: Knp_Manager_Permissions_Update_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Error al actualizar los permisos: ${i?.error}`)
};

const zh_cn2_knp_manager_permissions_update_failed = /** @type {(inputs: Knp_Manager_Permissions_Update_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`更新权限失败：${i?.error}`)
};

const ja_knp_manager_permissions_update_failed = /** @type {(inputs: Knp_Manager_Permissions_Update_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`権限の更新に失敗しました: ${i?.error}`)
};

const hi_knp_manager_permissions_update_failed = /** @type {(inputs: Knp_Manager_Permissions_Update_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`अनुमतियों को अपडेट करने में विफल: ${i?.error}`)
};

const pt_pt2_knp_manager_permissions_update_failed = /** @type {(inputs: Knp_Manager_Permissions_Update_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Falha ao atualizar as permissões: ${i?.error}`)
};

/**
* | output |
* | --- |
* | "Failed to update permissions: {error}" |
*
* @param {Knp_Manager_Permissions_Update_FailedInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const knp_manager_permissions_update_failed = /** @type {((inputs: Knp_Manager_Permissions_Update_FailedInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Knp_Manager_Permissions_Update_FailedInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_knp_manager_permissions_update_failed(inputs)
	if (locale === "de") return de_knp_manager_permissions_update_failed(inputs)
	if (locale === "it") return it_knp_manager_permissions_update_failed(inputs)
	if (locale === "ru") return ru_knp_manager_permissions_update_failed(inputs)
	if (locale === "es") return es_knp_manager_permissions_update_failed(inputs)
	if (locale === "zh-CN") return zh_cn2_knp_manager_permissions_update_failed(inputs)
	if (locale === "ja") return ja_knp_manager_permissions_update_failed(inputs)
	if (locale === "hi") return hi_knp_manager_permissions_update_failed(inputs)
	if (locale === "pt-PT") return pt_pt2_knp_manager_permissions_update_failed(inputs)
	return en_knp_manager_permissions_update_failed(inputs)
});